import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { ChangeEvent, useContext, useState } from "react";

const useEditDescription = () => {
  const { lead } = useContext(LeadPageContext);
  const [editDesctiptionModalOpen, setEditDescriptionModalOpen] =
    useState(false);
  const [description, setDescription] = useState(
    lead?.data?.lead?.desc || null
  );
  const handleChangeDescription = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setDescription(e.target.value);
  };
  return {
    description: {
      editDesctiptionModalOpen,
      setEditDescriptionModalOpen,
      handleChangeDescription,
      state: description,
      setState: setDescription,
      value: lead?.data?.lead?.desc,
    },
  };
};

export default useEditDescription;
